var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<highchart config=\"vm.map.config\" class=\"c-map__map\"></highchart>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/explore/exploreMap.jade
 ** module id = 792
 ** module chunks = 0
 **/